const reduxLoggerMessage = breadcrumb => breadcrumb.category === "console" && breadcrumb.message.startsWith("%c ");

const breadcrumbsFilter = breadcrumb => (reduxLoggerMessage(breadcrumb) ? null : breadcrumb);

export default breadcrumbsFilter;
